(() => {
 const parse=s=>{if(!/^\d{1,3}([,.]\d{1,2})?$/.test(s.trim()))return null;const [a,b='']=s.trim().replace(',','.').split('.');const n=Number(a)*100+Number(b.padEnd(2,'0'));return n>=500&&n<=50000?n:null;};
 function init(){document.querySelectorAll('[data-voucher-native-amount]').forEach(root=>{
  if(root.dataset.initialized)return;root.dataset.initialized='true';
  const section=root.closest('.shopify-section'),picker=section?.querySelector('variant-picker'),form=section?.querySelector('form[action$="/cart/add"]');
  if(!picker||!form)return;
  form.removeAttribute('on:submit');
  form.closest('product-form-component')?.removeAttribute('on:submit');
  picker.before(root);root.hidden=false;picker.hidden=true;picker.style.display='none';
  const motives=section.querySelector('[data-gutschein-motive]'),gallery=section.querySelector('media-gallery');
  if(motives&&gallery){
   motives.querySelectorAll('input').forEach(input=>input.setAttribute('form',form.id));
   gallery.after(motives);
   const selected=motives.querySelector('[aria-pressed="true"]')||motives.querySelector('[data-motiv-image]');
   if(selected)section.querySelectorAll('.product-media img').forEach(image=>{image.removeAttribute('srcset');image.removeAttribute('sizes');image.src=selected.dataset.motivImage;image.alt=selected.dataset.motivName;image.style.objectFit='contain';});
  }
  section.querySelectorAll('sticky-add-to-cart,shopify-accelerated-checkout').forEach(el=>{el.hidden=true;el.style.display='none';});
  const field=root.querySelector('input'),error=root.querySelector('[role="alert"]');
  const prices=section.querySelectorAll('.product-details__fallback-price-current, .price');
  let busy=false;
  field.addEventListener('input',()=>{error.textContent='';const n=parse(field.value);if(n!==null)prices.forEach(price=>price.textContent=new Intl.NumberFormat('de-DE',{style:'currency',currency:'EUR'}).format(n/100));});
  window.addEventListener('submit',async event=>{
   if(event.target!==form)return;
   event.preventDefault();event.stopImmediatePropagation();
   if(busy)return;
   const amount=parse(field.value);
   if(amount===null){error.textContent='Bitte einen Betrag von 5,00 bis 500,00 € eingeben.';field.focus();return;}
   busy=true;error.textContent='Gutscheinbetrag wird vorbereitet …';
   try{
    const response=await fetch('/apps/vc-gutscheine',{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json'},body:JSON.stringify({mode:'variant',productId:root.dataset.productId,amount:(amount/100).toFixed(2)})});
    if(!response.headers.get('content-type')?.includes('application/json'))throw new Error('Betragsdienst antwortet nicht korrekt ('+response.status+'). Bitte erneut versuchen.');
    const data=await response.json();
    if(!response.ok||!/^\d+$/.test(data.variantId||''))throw new Error(data.error||'Der Gutscheinbetrag konnte nicht vorbereitet werden.');
    form.querySelector('[name="id"]').value=data.variantId;
    const {CartAddEvent}=await import('@theme/events');
    const payload=new FormData(form);
    payload.set('id',data.variantId);
    motives?.querySelectorAll('input[name]').forEach(input=>payload.set(input.name,input.value));
    payload.set('sections',[...document.querySelectorAll('cart-items-component[data-section-id]')].map(el=>el.dataset.sectionId).join(','));
    let added;
    for(let attempt=0;attempt<8;attempt++){
     const cartResponse=await fetch('/cart/add.js',{method:'POST',credentials:'same-origin',headers:{'Accept':'application/json','X-Requested-With':'XMLHttpRequest'},body:payload});
     added=await cartResponse.json();
     if(cartResponse.ok&&!added.status)break;
     if(cartResponse.status!==422||attempt===7||!/sold out|ausverkauft/i.test(added.message||added.description||''))throw new Error(added.description||added.message||'Der Gutschein konnte nicht hinzugefügt werden.');
     await new Promise(resolve=>setTimeout(resolve,1500));
    }
    error.textContent='';
    form.closest('product-form-component').dispatchEvent(new CartAddEvent({},data.variantId,{source:'product-form-component',itemCount:Number(payload.get('quantity'))||1,productId:root.dataset.productId,sections:added.sections}));
   }catch(e){error.textContent=e.message||'Bitte erneut versuchen.';}finally{busy=false;}
  },true);
 });}
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
 document.addEventListener('shopify:section:load',init);
})();
